import myPagination from './index.vue';
const customPagination2 = {
    install: function (Vue) {
        Vue.component('customPagination2', myPagination);
    }
};
// 导出分页组件
export default customPagination2;
